import React from "react";
import { Formik, Field, Form, FieldArray } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { TextArea } from "components/form";
import { GalleryField } from "components/form";
import SearchSelect from "utils/SearchSelect";
import MultySearchSelect from "utils/MultySearchSelect";
import extractValues from "utils/extractValues";
import SocialComponent from "utils/SocialComponent";
import AchievementComponent from "utils/AchievementComponent";
import MetaDataComponent from "utils/MetaDataComponent";
import TextFieldSlug from "components/form/TextFieldSlug";
// components

const positions = [
  { label: "دروازه‌بان", value: "goalkeeper" },
  { label: "مدافع میانی", value: "center-back" },
  { label: "مدافع چپ", value: "left-back" },
  { label: "مدافع راست", value: "right-back" },
  { label: "مدافع کناری چپ", value: "left-wing-back" },
  { label: "مدافع کناری راست", value: "right-wing-back" },
  { label: "مدافع آزاد", value: "sweeper" },
  { label: "هافبک دفاعی مرکزی", value: "central-defensive-midfielder" },
  { label: "هافبک میانی", value: "central-midfielder" },
  { label: "هافبک هجومی مرکزی", value: "central-attacking-midfielder" },
  { label: "هافبک چپ", value: "left-midfielder" },
  { label: "هافبک راست", value: "right-midfielder" },
  { label: "وینگر چپ", value: "left-winger" },
  { label: "وینگر راست", value: "right-winger" },
  { label: "مهاجم", value: "striker" },
  { label: "مهاجم هدف", value: "center-forward" },
  { label: "مهاجم دوم", value: "second-striker" },
];

export default function Add(props) {
  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const result = extractValues(values, ["team", "leagues"]);

            await props.submit(result);

            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.name"
                    slugFieldName="translations.fa.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام (en):"
                    name="translations.en.name"
                    slugFieldName="translations.en.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نام خانوادگی"
                    label="نام خانوادگی :"
                    name="translations.fa.lastName"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام خانوادگی(en)"
                    label="نام خانوادگی(en) :"
                    name="translations.en.lastName"
                    component={TextField}
                  />

                  <Field
                    placeholder="ملیت"
                    label="ملیت :"
                    name="translations.fa.nationality"
                    component={TextField}
                  />
                  <Field
                    placeholder="ملیت(en)"
                    label="ملیت(en) :"
                    name="translations.en.nationality"
                    component={TextField}
                  />

                  <Field
                    placeholder="محل تولد"
                    label="محل تولد :"
                    name="translations.fa.placeOfBirth"
                    component={TextField}
                  />
                  <Field
                    placeholder="محل تولد(en)"
                    label="محل تولد(en) :"
                    name="translations.en.placeOfBirth"
                    component={TextField}
                  />

                  <Field
                    placeholder=" پای غالب (چپ یا راست)"
                    label="پای غالب (چپ یا راست) :"
                    name="translations.fa.dominantFoot"
                    component={TextField}
                    // validate={isUserName}
                  />
                  <Field
                    placeholder="پای غالب (چپ یا راست) (en)"
                    label="پای غالب (چپ یا راست) (en) :"
                    name="translations.en.dominantFoot"
                    component={TextField}
                    // validate={isUserName}
                  />

                  <Field
                    placeholder="نامک"
                    label="نامک:"
                    name="translations.fa.slug"
                    component={TextField}
                  />
                  <Field
                    placeholder="نامک(en)"
                    label="نامک(en) :"
                    name="translations.en.slug"
                    component={TextField}
                  />

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ تولد :"
                      name="birthDate"
                      component={PersianDataPicker}
                    />
                  </div>
                  <div className="user-datepicker">
                    <Field
                      label="تاریخ شروع قرار داد :"
                      name="contractStartDate"
                      component={PersianDataPicker}
                    />
                  </div>
                  <div className="user-datepicker">
                    <Field
                      label="تاریخ پایان قرار داد :"
                      name="contractEndDate"
                      component={PersianDataPicker}
                    />
                  </div>
                  <Field
                    label="وضعیت :"
                    name="isActive"
                    component={Select}
                    options={[
                      { value: true, label: "فعال" },
                      { value: false, label: "غیر فعال" },
                    ]}
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label="تیم فعلی :"
                    name="team"
                    component={SearchSelect}
                    searchFields="translations.name"
                    collectionName="team"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label="لیگ ها:"
                    name="leagues"
                    component={MultySearchSelect}
                    searchFields="translations.name"
                    collectionName="league"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label=" موقعیت باریکن :"
                    name="position"
                    component={Select}
                    options={positions}
                    className="w-full px-3 py-2 border rounded"
                  />

                  <div className="intro-y">
                    <span> قد (cm):</span>
                    <Field
                      label="قد (cm) : "
                      name="height"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> وزن (kg):</span>
                    <Field
                      label="وزن (kg):"
                      name="weight"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span>تعداد کل گل‌ها :</span>
                    <Field
                      label="تعداد کل گل‌ها: "
                      name="totalGoals"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span>تعداد کل پاس گل‌ها :</span>
                    <Field
                      label="تعداد کل پاس گل‌ها: "
                      name="totalAssists"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span>تعداد کارت‌های زرد :</span>
                    <Field
                      label="تعداد کارت‌های زرد: "
                      name="totalYellowCards"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> تعداد کارت‌های قرمز:</span>
                    <Field
                      label=" تعداد کارت‌های قرمز: "
                      name="totalRedCards"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                  <div className="intro-y">
                    <span> تعداد کل مسابقات:</span>
                    <Field
                      label="  تعداد کل مسابقات: "
                      name="totalMatches"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> مجموع دقایق بازی:</span>
                    <Field
                      label="مجموع دقایق بازی: "
                      name="totalMinutesPlayed"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> تعداد کلین شیت (برای دروازه‌بان‌ها):</span>
                    <Field
                      label="تعداد کلین شیت (برای دروازه‌بان‌ها): "
                      name="cleanSheets"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> ارزش بازار بازیکن:</span>
                    <Field
                      label=" ارزش بازار بازیکن: "
                      name="marketValue"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> شماره بازیکن:</span>
                    <Field
                      label="شماره بازیکن: "
                      name="shirtNumber"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                </div>
                <div className="w-full flex justify-between">
                  <div className="w-full">
                    <Field
                      label="تصویر"
                      name="profileImage"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <AchievementComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Player"
                />
                <SocialComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Player"
                />
                <MetaDataComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Player"
                />
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
